import { Navigate } from 'react-router-dom';

export function ReportPage() {
  return <Navigate to="/report/estimated-revenue" replace />;
}